import { render, staticRenderFns } from "./GenerateRenewed.vue?vue&type=template&id=70c15ce0&"
import script from "./GenerateRenewed.vue?vue&type=script&lang=js&"
export * from "./GenerateRenewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports